import React from "react";

const GenderSelection = ({ gender, changeGender }) => {
  return(
    <div>
      <label>Search for clothes for:</label>&nbsp;
      <select onChange={changeGender}
        value={gender}>
        <option value="Both" >Either</option>
        <option value="Boys" >Boys</option>
        <option value="Girls" >Girls</option>
      </select>
    </div>
  );
};

GenderSelection.propTypes = {
  gender: React.PropTypes.string.isRequired,
  changeGender: React.PropTypes.func.isRequired,
};

export default GenderSelection;



/** WEBPACK FOOTER **
 ** ./src/components/SettingsForm/GenderSelection.js
 **/